export default __webpack_public_path__ + "static/media/mat.2de1fb50.jpg";